
import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import CartPage from '../pages/cart/page';
import CheckoutPage from '../pages/checkout/page';
import AboutPage from '../pages/about/page';
import ContactPage from '../pages/contact/page';
import SupportPage from '../pages/support/page';
import FAQPage from '../pages/faq/page';
import BlogPage from '../pages/blog/page';
import ProductPage from '../pages/product/page';
import NotFound from '../pages/NotFound';
import PrivacyPage from '../pages/privacy/page';
import TermsPage from '../pages/terms/page';
import RefundPage from '../pages/refund/page';
import CookiesPage from '../pages/cookies/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/product/:id',
    element: <ProductPage />
  },
  {
    path: '/cart',
    element: <CartPage />
  },
  {
    path: '/checkout',
    element: <CheckoutPage />
  },
  {
    path: '/about',
    element: <AboutPage />
  },
  {
    path: '/contact',
    element: <ContactPage />
  },
  {
    path: '/support',
    element: <SupportPage />
  },
  {
    path: '/faq',
    element: <FAQPage />
  },
  {
    path: '/blog',
    element: <BlogPage />
  },
  {
    path: '/privacy',
    element: <PrivacyPage />,
  },
  {
    path: '/terms',
    element: <TermsPage />,
  },
  {
    path: '/refund',
    element: <RefundPage />,
  },
  {
    path: '/cookies',
    element: <CookiesPage />,
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
